import React from 'react'
import { BsGrid3X2Gap } from 'react-icons/bs'
import { FaList } from 'react-icons/fa'

export const MODE_OPTIONS = [
  {
    value: {
      type: 'grid',
      icon: <BsGrid3X2Gap className='' size={16} />
    }
  },
  { value: { type: 'list', icon: <FaList size={16} /> } }
]
